<template>
<div class="modal fade" id="modalTabEmployeer" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Usuários MarQTab.</h4>
      </div>

      <div class="modal-body">
        <!-- Loading -->
        <div v-if="loadingListModal" class="loading center_vertical">
          <div class="loader-mini-box">
            <div class="spinner-box">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </div>

        <!-- Tabela -->
        <div v-if="!loadingListModal">
          <div class="modal-table">

            <div v-if="dataListModal.length" class="mr-table">
              <div class="table-responsive table-clean">
                <div class="table-scrollable table-scrollable-borderless">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="certa"> Cod </th>
                        <th class="certa"> Nome </th>
                        <th class="certa"> Pin
                        <th class="certa"> ID </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="e in dataListModal">
                        <td class="no-wrap">{{e.code}}</td>
                        <td>{{e.name}}</td>
                        <td>{{e.pin}}</td>
                        <td>{{e.id}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!dataListModal.length" class="empty-modal">
            <p class="nunito">Sem usuários relacionado ao MarQTab.</p>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  GET_TAB_EMPLOYEES
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";

export default {
  name: "modalTabEmployeer",
  props: ['objRS'],
  watch: {
    objRS: function (val) {
      this.getList(val.companyId, val.context);
    }
  },
  data() {
    return {
      loadingListModal: '',
      dataListModal: [],
    }
  },
  methods: {
    closeModal() {
      $('#modalTabEmployeer').modal('toggle');
    },
    getList(id, context) {
      this.loadingListModal = true;

      let url = GET_TAB_EMPLOYEES;
      url += "?i=" + id;
      url += "&isFromMaster=true";

      UTIL_SERVICE.console("URL SEARCH:", "id:" + id + ", Context:" + context);
      REQUEST_SERVICE.requestContext('GET', url, context).then((response) => {
        UTIL_SERVICE.console("RESULT GET_TAB_EMPLOYEES:", response.data);

        this.dataListModal = response.data;
        this.loadingListModal = false;
      }).catch((reason) => {
        this.loadingListModal = false;

        this.closeModal();

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  }
}
</script>

<style lang="scss">
#modalTabEmployeer {
  .photo-user {
    border-radius: 100px;
    width: 60px;
    height: 60px;
    position: relative;
    top: -1px;

    &:last-of-type {
      margin-left: 5px;
      margin-right: 4px;
    }
  }

  @media (min-width: 768px) {
    .modal-dialog {
      width: 1000px;
      margin: 30px auto;
    }
  }

  .loader-mini-box {
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .spinner-box {
      height: 64px;
      text-align: center;

      .rect2 {
        -webkit-animation-delay: -1.1s;
        animation-delay: -1.1s;
      }

      .rect3 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
      }

      .rect4 {
        -webkit-animation-delay: -0.9s;
        animation-delay: -0.9s;
      }

      .rect5 {
        -webkit-animation-delay: -0.8s;
        animation-delay: -0.8s;
      }

      >div {
        background-color: #3598dc;
        width: 4px;
        height: 64px;
        display: inline-block;
        -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
        animation: sk-stretchdelay 1.2s infinite ease-in-out;
        margin-right: 4px;
      }
    }
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .double-btn-center {
    display: block;
    margin: 0 auto 50px;

    .first {
      background: #00a651;
      color: #fff;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #008d45;
      }
    }

    .second {
      background: #0F77AE;
      color: #fff;
      width: 49%;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #054F91;
      }
    }

    .third {
      background: #c29d0b;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #aa890a;
      }
    }

    .four {
      background: #e74a4e;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #e43338;
      }
    }
  }

  .send-btn-modal {
    background: #3598dc;
    color: #fff;
    border: none;
    padding: 0 15px;
    height: 37px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 16px;
    display: inline-block;
    margin: 0 auto 0 0;

    &:hover {
      background-color: #054F91;
    }
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalTabEmployeer.vue